import {LangKeyType} from '../../../../../../provider/locale/translation/type';
import {CompaniesMapStatsEnum} from '../../../../../../service/dashboard/dashboard-type';

export const onlinePresenceValueLocalizationMap: Record<CompaniesMapStatsEnum, LangKeyType> = {
    [CompaniesMapStatsEnum.impressions]: 'DASHBOARD_PAGE__COMPANIES_MAP__STAT__IMPRESSIONS',
    [CompaniesMapStatsEnum.actions]: 'DASHBOARD_PAGE__COMPANIES_MAP__STAT__ACTIONS',
    [CompaniesMapStatsEnum.conversion]: 'DASHBOARD_PAGE__COMPANIES_MAP__STAT__CONVERSION',
};
